// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMask from 'v-mask'
import App from './App'
import VueResource from 'vue-resource'
import router from './router'
import jQuery from 'jquery/jquery.js'
import BootstrapCss from 'bootstrap/dist/css/bootstrap.min.css'
import BootstrapJs from 'bootstrap/dist/js/bootstrap.min.js'
import './font-awesome/css/font-awesome.min.css'
Vue.use(VueResource)
Vue.use(VueMask)

Vue.use(jQuery)
Vue.use(BootstrapCss)
Vue.use(BootstrapJs)

// Vue.http.options.root = 'http://localhost:57222/api/atendimento'
// Vue.http.options.root = 'http://192.168.1.102:5555/api/atendimento'
Vue.http.options.root = 'http://api.fastrhluandre.com.br/api/atendimento'
// Vue.http.options.root = 'http://dev-luandre-oldapi.azurewebsites.net/api/atendimento'
Vue.config.silent = true
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App,
    jQuery
  }
})



// WEBPACK FOOTER //
// ./src/main.js